var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { AlertService } from '../../../core/services/alert.service';
import { OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { map, switchMap, take, filter } from 'rxjs/operators';
import { Role, RoleDetail, RoleUserSelections, readParameterFromRouterState, RolesService, GoAction, IAM_ROUTE, IAMUser } from '@app/core';
import { State, LoadingRoleDetailsAction, selectRoleDetail, selectRoleUserSelections, selectUserToEdit, SelectUsersForRoleAction } from '../../state';
var shouldLoadRole = function (roleDetail) {
    return roleDetail === undefined || roleDetail.role === undefined;
};
var ɵ0 = shouldLoadRole;
var ManageUserScopesComponent = /** @class */ (function () {
    function ManageUserScopesComponent(activatedRoute, store, alertService, rolesService) {
        var _this = this;
        this.activatedRoute = activatedRoute;
        this.store = store;
        this.alertService = alertService;
        this.rolesService = rolesService;
        this.isSubmitting$ = new BehaviorSubject(false);
        this.failedSubmit$ = new BehaviorSubject(false);
        this.isValid = false;
        this.addUserScopeMode = false;
        this.useProjectCommitteeHandler = false;
        this.submitSubscription = undefined;
        this.roleId = this.getRoleId();
        var maybeRoleDetail$ = this.selectRoleDetail$();
        this.loadRoleDetailsIfNecessary(maybeRoleDetail$);
        this.role$ = this.getRole$(maybeRoleDetail$);
        this.roleDetail$ = maybeRoleDetail$;
        this.user$ = this.store.pipe(select(selectUserToEdit(this.roleId)));
        this.user$.pipe(take(1)).subscribe(function (user) {
            _this._selectedUser = user;
        });
    }
    ManageUserScopesComponent.prototype.ngOnInit = function () { };
    ManageUserScopesComponent.prototype.onOptionSelected = function (option) {
        this.useProjectCommitteeHandler = option === 'project|committee';
    };
    ManageUserScopesComponent.prototype.onSaved = function () {
        this.addUserScopeMode = false;
        this.useProjectCommitteeHandler = false;
        this._selectedUser = __assign({}, this._selectedUser);
    };
    ManageUserScopesComponent.prototype.ngOnDestroy = function () {
        if (this.submitSubscription) {
            this.submitSubscription.unsubscribe();
        }
    };
    ManageUserScopesComponent.prototype.addUserScope = function () {
        this.addUserScopeMode = true;
    };
    ManageUserScopesComponent.prototype.updateValidity = function (isValid) {
        this.isValid = isValid;
    };
    ManageUserScopesComponent.prototype.submit = function () {
        var _this = this;
        if (!this.isValid) {
            return;
        }
        var submit$ = this.store.pipe(select(selectRoleUserSelections(this.roleId)), switchMap(function (roleUserSelections) {
            var request = roleUserSelections;
            if (!request.users || !request.users.length) {
                request.users = [_this._selectedUser];
            }
            return _this.rolesService.updateUserScope(_this.roleId, roleUserSelections);
        }));
        this.submitSubscription = submit$.subscribe(function (_) {
            _this.reloadRoleDetail();
            _this.alertService.success("Successfully updated user.");
        }, function (err) {
            _this.alertService.error('Failed to assign user to role.');
        });
    };
    ManageUserScopesComponent.prototype.reloadRoleDetail = function () {
        this.store.dispatch(new LoadingRoleDetailsAction(this.roleId));
        this.store.dispatch(new SelectUsersForRoleAction({ roleId: this.roleId, selectedUsers: [this._selectedUser] }));
        this.addUserScopeMode = false;
    };
    ManageUserScopesComponent.prototype.cancel = function () {
        this.addUserScopeMode = false;
    };
    ManageUserScopesComponent.prototype.goToRoleDetailsPage = function () {
        this.store.dispatch(new GoAction(['/', IAM_ROUTE, 'roles', this.roleId]));
    };
    ManageUserScopesComponent.prototype.setSubmitting = function () {
        this.isSubmitting$.next(true);
        this.failedSubmit$.next(false);
    };
    ManageUserScopesComponent.prototype.failSubmitting = function () {
        this.isSubmitting$.next(false);
        this.failedSubmit$.next(true);
    };
    ManageUserScopesComponent.prototype.getRoleId = function () {
        var roleId = readParameterFromRouterState(this.activatedRoute, 'id');
        if (roleId === undefined) {
            throw new Error('role id not in route');
        }
        return roleId;
    };
    ManageUserScopesComponent.prototype.selectRoleDetail$ = function () {
        return this.store.pipe(select(selectRoleDetail(this.roleId)));
    };
    ManageUserScopesComponent.prototype.getRole$ = function (maybeRoleDetail$) {
        var roleDetail$ = maybeRoleDetail$.pipe(filter(function (maybeRoleDetail) { return maybeRoleDetail !== undefined; }));
        return roleDetail$.pipe(map(function (roleDetail) { return roleDetail.role; }));
    };
    ManageUserScopesComponent.prototype.loadRoleDetailsIfNecessary = function (maybeRoleDetail$) {
        var _this = this;
        return maybeRoleDetail$
            .pipe(take(1), filter(shouldLoadRole))
            .subscribe(function () { return _this.store.dispatch(new LoadingRoleDetailsAction(_this.roleId)); });
    };
    return ManageUserScopesComponent;
}());
export { ManageUserScopesComponent };
export { ɵ0 };



// WEBPACK FOOTER //
// ./src/app/access-management/roles/manage-user-scopes/manage-user-scopes.component.ts.pre-build-optimizer.js